import type * as React from 'react';

interface ColorTicketDailyProps extends React.SVGProps<SVGSVGElement> {
  number?: string | number;
}

const SvgColorTicketDaily = ({ number = 1, ...props }: ColorTicketDailyProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g clipPath="url(#ColorTicketDaily_svg__a)">
      <path
        fill="url(#ColorTicketDaily_svg__b)"
        d="M24.15 4.334a4.51 4.51 0 0 0 6.14 5.604q.043.357.044.726v1.63c0 .755-.527 1.3-1.095 1.496a2.335 2.335 0 0 0 0 4.414c.568.196 1.094.741 1.095 1.495v1.631A6.334 6.334 0 0 1 24 27.664H8a6.334 6.334 0 0 1-6.333-6.334V19.7c0-.755.526-1.3 1.094-1.496a2.335 2.335 0 0 0 0-4.414c-.568-.196-1.094-.741-1.094-1.495v-1.63A6.334 6.334 0 0 1 8 4.33h16q.075.001.15.004"
      />
      {/* <path
        fill="red"
        d="M16.558 21.137c-.513 0-.868-.356-.868-.889v-7.403h-.035l-1.592 1.107a.78.78 0 0 1-.5.171c-.369 0-.635-.267-.635-.656 0-.274.11-.479.403-.684l2.017-1.415c.437-.308.71-.369 1.08-.369.622 0 .998.376.998.984v8.265c0 .533-.356.889-.868.889"
      /> */}
      <text
        x="15.5"
        y="17.5"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="14"
        fontWeight="600"
        fill="#fff"
        fontFamily="'SF Pro Rounded', 'Apple SD Gothic Neo', Arial, sans-serif"
        letterSpacing="-0.5px"
        style={{ pointerEvents: 'none', userSelect: 'none' }}
      >
        {number}
      </text>

      <circle cx={28.401} cy={5.844} r={3.407} fill="#C7D3F9" />
    </g>
    <defs>
      <linearGradient
        id="ColorTicketDaily_svg__b"
        x1={16}
        x2={16}
        y1={4.33}
        y2={27.664}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#839DEB" />
        <stop offset={1} stopColor="#9BB2F6" />
      </linearGradient>
      <clipPath id="ColorTicketDaily_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgColorTicketDaily;
